import { Dialog } from '@mui/material';
import React from 'react';

import { cellFormat } from '../../../../../../../lib/designSystem/Table/cellFormat';
import EnhancedTab from '../../../../../../../lib/designSystem/TabSimulation';
import FactoringResellMissingApprovalContainer from './components/Approval';
import ResellMain from './components/NewResell';
import ResellPayments from './components/Payments';

const ResellDetails = (props: any) => {
  const { resell, setResell, open, setOpen, setUp, edit, triggerSearch } =
    props;
  const startValue = 0;

  const newResell = !resell.status;

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <ResellMain
          resell={resell}
          setResell={setResell}
          setOpen={setOpen}
          setUp={setUp}
          edit={edit}
          triggerSearch={triggerSearch}
        />
      ),
    },
    {
      index: 0,
      label: 'Aprobación',
      disabled: true,
      component: (
        <FactoringResellMissingApprovalContainer
          resell={resell}
          setOpen={setOpen}
          setUp={setUp}
        />
      ),
    },
    {
      index: 0,
      disabled: newResell || resell.status === 'Recomprada',
      label: 'Pagos',
      component: <ResellPayments resell={resell} />,
    },
  ];

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={() => setOpen(false)}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={resell.id ? `Venta #${resell.id}` : 'Nueva venta a fondo'}
          startValue={startValue}
          tabs={tabs}
          chip={cellFormat(resell.status || 'Nuevo', 'status')}
        />
      </div>
    </Dialog>
  );
};

export default ResellDetails;
